import { render, staticRenderFns } from "./OperacaoMain.vue?vue&type=template&id=36174745&"
import script from "./OperacaoMain.vue?vue&type=script&lang=js&"
export * from "./OperacaoMain.vue?vue&type=script&lang=js&"
import style0 from "./OperacaoMain.vue?vue&type=style&index=0&id=36174745&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports